import React from 'react'
import css from '@styled-system/css'

const FormBase = ({ ...rest }) => {
  return <form
    css={css({ p: 3, bg: 'white' })} {...rest} />
}

export default FormBase
